import {
    Badge,
    Box,
    Button,
    Group,
    Modal,
    Paper,
    Select,
    SimpleGrid,
    Stack,
    Tabs,
    Text,
    TextInput,
    Textarea,
} from '@mantine/core';
import { faSpinnerThird, faTimeline } from '@fortawesome/pro-solid-svg-icons';
import { useEffect, useState } from 'react';

import CampaignEventsTable from '../../campaignEvents/CampaignEventsTable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CampaignEventsPanel = ({ campaign }) => {
    return (
        <>
            <CampaignEventsTable campaign={campaign} />
        </>
    );
};

const CampaignDetailsModal = ({ campaign, openTab, opened, close }) => {
    const [activeTab, setActiveTab] = useState('events');
    useEffect(() => {
        setActiveTab(openTab);
    }, [openTab]);

    return (
        <Modal.Root
            opened={opened}
            onClose={close}
            size='auto'>
            <Modal.Overlay />
            <Modal.Content>
                <Modal.Header>
                    <Modal.Title>
                        {campaign
                            ? `${campaign.name} Details`
                            : 'Campaign Details'}
                    </Modal.Title>
                    <Modal.CloseButton />
                </Modal.Header>
                <Modal.Body>
                    <Tabs
                        value={activeTab}
                        onChange={setActiveTab}>
                        <Tabs.List>
                            <Tabs.Tab
                                value='events'
                                leftSection={
                                    <FontAwesomeIcon icon={faTimeline} />
                                }>
                                Events
                            </Tabs.Tab>
                        </Tabs.List>

                        <Tabs.Panel
                            value='events'
                            py={'sm'}>
                            <CampaignEventsPanel campaign={campaign} />
                        </Tabs.Panel>
                    </Tabs>
                </Modal.Body>
            </Modal.Content>
        </Modal.Root>
    );
};
export default CampaignDetailsModal;
